import { GENERAL_CHAT_KEY } from "./config";

export const SESSION_TOKEN_HEADER = "X-Recruitment-Session-Token";

const tokenStore = new Map();

export const campaignKeyFromSessionId = (sessionId) => {
  const raw = String(sessionId ?? "").trim();
  if (!raw) return GENERAL_CHAT_KEY;
  const suffix = raw.includes("_") ? raw.split("_").pop() : raw;
  if (!suffix || suffix === "2002") return GENERAL_CHAT_KEY;
  return suffix;
};

export const campaignKeyFromCampaignId = (campaignId) =>
  campaignId == null || campaignId === "" ? GENERAL_CHAT_KEY : String(campaignId);

export const setRecruitmentSessionToken = (campaignKey, token) => {
  if (!campaignKey || !token) return;
  tokenStore.set(String(campaignKey), token);
};

export const getRecruitmentSessionToken = (campaignKey) =>
  tokenStore.get(String(campaignKey)) || null;

export const rememberRecruitmentSessionTokenFromResponse = (response, campaignKey) => {
  const headers = response?.headers || {};
  const token =
    headers[SESSION_TOKEN_HEADER] ||
    headers[SESSION_TOKEN_HEADER.toLowerCase()];
  if (token && campaignKey) {
    setRecruitmentSessionToken(campaignKey, token);
  }
  return token || null;
};

export const recruitmentAuthHeaders = (campaignKey) => {
  const token = getRecruitmentSessionToken(campaignKey);
  return token ? { [SESSION_TOKEN_HEADER]: token } : {};
};
